import {AfterViewInit, Component, Inject, ViewChildren, ViewEncapsulation} from '@angular/core';
import {NGXLogger} from 'ngx-logger';
import {UserService} from '../../../domain/user/service/user.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ToastService} from '../../../../../projects/shared/src/lib/toast.service';
import {SnsLoginService} from '../../../_service/sns-login.service';
import {NativeService} from '../../../_service/native.service';
import {MatTooltip} from "@angular/material/tooltip";
import {finalize, timeout} from 'rxjs/operators';


@Component({
  selector: 'app-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginDialogComponent implements AfterViewInit {
  @ViewChildren(MatTooltip)
  tooltips!: MatTooltip[];
  showServiceInfo = false
  showPassword = false;
  form = new UntypedFormGroup({
    username: new UntypedFormControl(null, [Validators.required]),
    password: new UntypedFormControl(null, [Validators.required])
  });
  showGoogleLogin = false;
  lastSignIn = 'checkteam';
  loginSubmitting = false;

  constructor(private readonly log: NGXLogger,
              @Inject(MAT_DIALOG_DATA) private readonly data: any,
              private readonly dialogRef: MatDialogRef<LoginDialogComponent>,
              private readonly toast: ToastService,
              private readonly nativeService: NativeService,
              private readonly userService: UserService,
              private readonly snsService: SnsLoginService) {
    this.dialogRef.addPanelClass('login-dialog-panel');

    if (this.data.redirectPath) {
      this.showServiceInfo = true
    }

    this.showGoogleLogin = !this.nativeService.isNative() || this.nativeService.isFlutterApp();
  }

  ngAfterViewInit(): void {
    this.nativeService.checkLastLogin()
      .then((sns: any) => {
        this.log.debug('last sign in', sns);
        this.lastSignIn = sns;

        this.tooltips.filter(tooltip => tooltip.tooltipClass === this.lastSignIn)
          .forEach((lastSignInTooltip) => {
            lastSignInTooltip.disabled = false;
            const timeout = setTimeout(() => {
              lastSignInTooltip.show();
              clearTimeout(timeout);
            },300)
          })
      });
  }

  toggleShowPassword(event: MouseEvent) {
    event.stopPropagation();
    this.showPassword = !this.showPassword;
  }

  loginSns(sns: string) {
    if (this.nativeService.isFlutterApp() && sns !== 'apple') {
      this.nativeService.loginNativeSns(sns);
    } else {
      this.snsService.openSnsLoginDialog(sns)
    }
  }

  submit() {
    if (this.loginSubmitting) {
      return;
    }

    if (this.form.invalid) {
      this.toast.show('아이디와 비밀번호를 입력하세요.');
      return;
    }

    const controls = this.form.controls;
    this.loginSubmitting = true;
    // 로그인 다이얼로그 안에서만 진행 상태를 표시하고 장시간 무응답 요청은 종료한다.
    this.userService.login(controls.username.value, controls.password.value, !this.showServiceInfo, true)
      .pipe(
        timeout(15000),
        finalize(() => this.loginSubmitting = false)
      )
      .subscribe({
        next: (success: boolean) => {
          if (success) {
            this.log.debug("Login Success")
            const principal = {
              service: 'checkteam',
              username: this.form.value.username,
              password: this.form.value.password
            }
            this.log.debug("Call GET FCM KEY");
            this.nativeService.getFcmKey();
            this.log.debug("Call REMEMBER ME");
            this.nativeService.rememberMe(principal);
          }

          this.dialogRef.close(success)
        },
        error: (error: Error) => {
          if (error.name === 'TimeoutError') {
            this.toast.show('로그인 응답이 지연되고 있어요. 잠시 후 다시 시도해 주세요.');
          }
        }
      });
  }
}
